import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import styles from './PrivateLayout.module.scss'

export type PrivateLayoutProps = {
  header: ReactNode
  sidebar?: ReactNode
}

export const PrivateLayout = ({ header, sidebar }: PrivateLayoutProps) => {
  return (
    <>
      {header}
      {sidebar}
      <main id="main">
        <section className={`d-flex flex-column flex-grow-1 ${styles.section}`}>
          <Outlet context={{ noTopMargin: true }} />
        </section>
      </main>
    </>
  )
}
